import * as angular from "angular";
import "angular-ui-router";
import "angular-ui-bootstrap";
import "ui-select";
import "angular-resource";
import "angular-recaptcha";
import "ng-password-meter/dist/ng-password-meter.js";
import "ng-password-meter/dist/ng-password-meter.css";
import { LoginPageComponent } from "./components/loginPage/LoginPageComponent";
import { RegisterPageComponent } from "./components/registerPage/RegisterPageComponent";
import { PasswordResetPageComponent } from "./components/passwordResetPage/PasswordResetPageComponent";
import { ProfilePageComponent } from "./components/profilePage/ProfilePageComponent";
import { ForgetPasswordPageComponent } from "./components/forgetPasswordPage/ForgetPasswordPageComponent";
import { MigrationPageComponent } from './components/migrationPage/MigrationPageComponent';
import { config as routesConfig } from "./configs/routes";
import { AccountService } from "./core/services/AccountService";
import { CategoryService } from "./core/services/CategoryService";
import { initialize } from "./initialize";

angular.module("app.account", ["ui.router", "ui.bootstrap", "ui.select", "ngResource", "vcRecaptcha", "ngPasswordMeter"])
    .service("AccountService", AccountService)
    .service("CategoryService", CategoryService)
    .component("loginPage", new LoginPageComponent())
    .component("registerPage", new RegisterPageComponent())
    .component("passwordResetPage", new PasswordResetPageComponent())
    .component("profilePage", new ProfilePageComponent())
    .component("forgetPasswordPage", new ForgetPasswordPageComponent())
    .component("migrationPage", new MigrationPageComponent())
    .config(routesConfig)
    .run(initialize);
